// extracted by mini-css-extract-plugin
export var auto = "_4o-1";
export var spinner = "_4o-0";